<template>
    <!-- eslint-disable max-len -->
    <Layout v-bind:class="$style.body">
        <h1 class="c23">
            <span class="c12 c6">PRIVACY POLICY</span>
        </h1>
        <p class="c11">
            <span class="c12 c20">&nbsp;</span>
        </p>
        <p class="c11">
            <span class="c1">Effective date: 10/09/2020</span>
        </p>
        <p class="c11">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_80laymq897z3-0 start first" start="1">
            <li class="c0">
                <span class="c2">Introduction</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c15">Welcome to </span><span class="c6">CitizenJ.org</span><span class="c1">.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c15">CitizenJ.org (&ldquo;us&rdquo;, &ldquo;we&rdquo;, or &ldquo;our&rdquo;) operates https://citizenj.org (hereinafter referred to as &ldquo;</span><span class="c6">Service</span><span class="c1">&rdquo;).</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">Our Privacy Policy governs your visit to https://citizenj.org, and explains how we collect, safeguard and disclose information that results from your use of our Service. </span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We use your data to provide and improve Service. By using Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c15">Our Terms and Conditions (&ldquo;</span><span class="c6">Terms</span><span class="c15">&rdquo;) govern all use of our Service and together with the Privacy Policy constitutes your agreement with us (&ldquo;</span><span class="c6">agreement</span><span class="c1">&rdquo;).</span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0 start" start="2">
            <li class="c0">
                <span class="c2">Definitions</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c6">SERVICE </span><span class="c1">means the https://citizenj.org website operated by CitizenJ.org.</span>
        </p>
        <p class="c11">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c6">PERSONAL DATA</span><span class="c1">&nbsp;means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).</span>
        </p>
        <p class="c11">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c6">USAGE DATA</span><span class="c1">&nbsp;is data collected automatically either generated by the use of Service or from Service infrastructure itself (for example, the duration of a page visit).</span>
        </p>
        <p class="c11">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c6">COOKIES</span><span class="c1">&nbsp;are small files stored on your device (computer or mobile device).</span>
        </p>
        <p class="c11">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c6">DATA CONTROLLER</span><span class="c1">&nbsp;means a natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal data are, or are to be, processed. For the purpose of this Privacy Policy, we are a Data Controller of your data.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c6">DATA PROCESSORS (OR SERVICE PROVIDERS)</span><span class="c1">&nbsp;means any natural or legal person who processes the data on behalf of the Data Controller. We may use the services of various Service Providers in order to process your data more effectively.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c6">DATA SUBJECT </span><span class="c1">is any living individual who is the subject of Personal Data.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c6">THE USER </span><span class="c1">is the individual using our Service. The User corresponds to the Data Subject, who is the subject of Personal Data.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="3">
            <li class="c0">
                <span class="c2">Information Collection and Use</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We collect several different types of information for various purposes to provide and improve our Service to you.</span>
        </p>
        <p class="c11">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="4">
            <li class="c0">
                <span class="c2">Types of Data Collected</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c12 c6">Personal Data</span>
        </p>
        <p class="c5">
            <span class="c15">While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (&ldquo;</span><span class="c6">Personal Data</span><span class="c1">&rdquo;). Personally identifiable information may include, but is not limited to:</span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_xbcui3mhis41-1 start" start="1">
            <li class="c3">
                <span class="c1">Email address</span>
            </li>
        </ol>
        <p class="c7">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_xbcui3mhis42-1 start" start="1">
            <li class="c3">
                <span class="c1">Comments and meta data related to webpages you submit</span>
            </li>
        </ol>
        <p class="c7">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_6ywyuwdy2n8v-1 start" start="1">
            <li class="c3">
                <span class="c1">Cookies and Usage Data</span>
            </li>
        </ol>
        <p class="c7">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by emailing at info@citizenj.org.</span>
        </p>
        <p class="c8 c17">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c12 c6">Usage Data</span>
        </p>
        <p class="c5">
            <span class="c15">We may also collect information that your browser sends whenever you visit our Service or when you access Service by or through a mobile device (&ldquo;</span><span class="c6">Usage Data</span><span class="c1">&rdquo;).</span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">This Usage Data may include information such as your computer&#39;s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">When you access Service with a mobile device, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.</span>
        </p>
        <p class="c5">
            <span class="c1"><strong>Chrome Extension Data:</strong> When you submit a comment using the Chrome Extension, we store your comment, along with meta data about the website, including the page title, description and urls related to the page in order to create a list of comments related to similar webpages.</span>
        </p>
        <p class="c8 c17">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c12 c6">Tracking Cookies Data</span>
        </p>
        <p class="c5">
            <span class="c1">We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyze our Service.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">Examples of Cookies we use:</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_oxfw1p9eqhqg-1 start" start="1">
            <li class="c3">
                <span class="c6">Session Cookies:</span><span class="c1">&nbsp;We use Session Cookies to operate our Service.</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_youeqaq754ns-1 start" start="1">
            <li class="c3">
                <span class="c6">Preference Cookies:</span><span class="c1">&nbsp;We use Preference Cookies to remember your preferences and various settings.</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_8qh9pcr504v3-1 start" start="1">
            <li class="c3">
                <span class="c6">Security Cookies:</span><span class="c1">&nbsp;We use Security Cookies for security purposes.</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_9zu2lpt5uavb-1 start" start="1">
            <li class="c3">
                <span class="c6">Advertising Cookies:</span><span class="c1">&nbsp;Advertising Cookies are used to serve you with advertisements that may be relevant to you and your interests.</span>
            </li>
        </ol>
        <p class="c7">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="5">
            <li class="c0">
                <span class="c2">Use of Data</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">CitizenJ.org uses the collected data for various purposes:</span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_b9z9fzb619q7-1 start" start="1">
            <li class="c3">
                <span class="c1">to provide and maintain our Service;</span>
            </li>
        </ol>
        <p class="c7">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_x6xe5yrpz8v0-1 start" start="1">
            <li class="c3">
                <span class="c1">to notify you about changes to our Service; </span>
            </li>
        </ol>
        <p class="c7">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_o0mnq5lkdez8-1 start" start="1">
            <li class="c3">
                <span class="c1">to allow you to participate in interactive features of our Service when you choose to do so; </span>
            </li>
        </ol>
        <p class="c7">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_k26oji9aoib1-1 start" start="1">
            <li class="c3">
                <span class="c1">to provide customer support; </span>
            </li>
        </ol>
        <p class="c7">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_6w52pmj7bv32-1 start" start="1">
            <li class="c3">
                <span class="c1">to gather analysis or valuable information so that we can improve our Service; </span>
            </li>
        </ol>
        <p class="c7">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_aua965ctqr26-1 start" start="1">
            <li class="c3">
                <span class="c1">to monitor the usage of our Service;</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_zalxpwf09t7t-1 start" start="1">
            <li class="c3">
                <span class="c1">to detect, prevent and address technical issues;</span>
            </li>
        </ol>
        <p class="c7">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_r0n8soatahok-1 start" start="1">
            <li class="c3">
                <span class="c1">to fulfill any other purpose for which you provide it;</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_bulneqyqzcp7-1 start" start="1">
            <li class="c3">
                <span class="c1">to carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection;</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_55dvgy2pvh2e-1 start" start="1">
            <li class="c3">
                <span class="c1">to provide you with notices about your account and/or subscription, including expiration and renewal notices, email-instructions, etc.;</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_r9c6waa0jmnp-1 start" start="1">
            <li class="c3">
                <span class="c1">to provide you with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information;</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_8egeqw6xqv1p-1 start" start="1">
            <li class="c3">
                <span class="c1">in any other way we may describe when you provide the information;</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_atfbkrdl1c6q-1 start" start="1">
            <li class="c3">
                <span class="c1">for any other purpose with your consent. </span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="6">
            <li class="c0">
                <span class="c2">Retention of Data</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.</span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer time periods.</span>
        </p>
        <p class="c11">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="7">
            <li class="c0">
                <span class="c2">Transfer of Data</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">Your information, including Personal Data, may be transferred to &ndash; and maintained on &ndash; computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.</span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">If you are located outside United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to United States and process it there.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">CitizenJ.org will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organisation or a country unless there are adequate controls in place including the security of your data and other personal information.</span>
        </p>
        <p class="c11">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="8">
            <li class="c0">
                <span class="c2">Disclosure of Data</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We may disclose personal information that we collect, or you provide:</span>
        </p>
        <p class="c11">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_3b8hlpdf8wp7-1 start" start="1">
            <li class="c3">
                <span class="c12 c6">Disclosure for Law Enforcement.</span>
            </li>
        </ol>
        <p class="c8 c9">
            <span class="c1">Under certain circumstances, we may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities.</span>
        </p>
        <p class="c11 c18">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_u1exs7p2w8o3-1 start" start="1">
            <li class="c3">
                <span class="c12 c6">Other cases. We may disclose your information also:</span>
            </li>
        </ol>
        <p class="c8 c9">
            <span class="c12 c6">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_bftuli5ekzsg-2 start" start="1">
            <li class="c10">
                <span class="c1">to our subsidiaries and affiliates;</span>
            </li>
        </ol>
        <p class="c8 c14">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_421mk1biu93s-2 start" start="1">
            <li class="c10">
                <span class="c1">to fulfill the purpose for which you provide it;</span>
            </li>
        </ol>
        <p class="c8 c14">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_7gefdvwpn9to-2 start" start="1">
            <li class="c10">
                <span class="c1">if we believe disclosure is necessary or appropriate to protect the rights, property, or safety of the Company, our customers, or others.</span>
            </li>
        </ol>
        <p class="c8 c14">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="9">
            <li class="c0">
                <span class="c2">Security of Data</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</span>
        </p>
        <p class="c11">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="10">
            <li class="c0">
                <span class="c2">Your Data Protection Rights Under General Data Protection Regulation (GDPR)</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">If you are a resident of the European Union (EU) and European Economic Area (EEA), you have certain data protection rights, covered by GDPR. &ndash; See more at https://eur-lex.europa.eu/eli/reg/2016/679/oj </span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We aim to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please email us at info@citizenj.org. </span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">In certain circumstances, you have the following data protection rights:</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_ynfn7lzf5h13-1 start" start="1">
            <li class="c3">
                <span class="c1">the right to access, update or to delete the information we have on you;</span>
            </li>
        </ol>
        <p class="c8 c9">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_d0t3ybhryehg-1 start" start="1">
            <li class="c3">
                <span class="c1">the right of rectification. You have the right to have your information rectified if that information is inaccurate or incomplete;</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_w3li5e270vxa-1 start" start="1">
            <li class="c3">
                <span class="c1">the right to object. You have the right to object to our processing of your Personal Data;</span>
            </li>
        </ol>
        <p class="c8 c9">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_ppgg95863ce3-1 start" start="1">
            <li class="c3">
                <span class="c1">the right of restriction. You have the right to request that we restrict the processing of your personal information;</span>
            </li>
        </ol>
        <p class="c8 c9">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_a3z8b7lq78ye-1 start" start="1">
            <li class="c3">
                <span class="c1">the right to data portability. You have the right to be provided with a copy of your Personal Data in a structured, machine-readable and commonly used format;</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_wrnj8gif9gjw-1 start" start="1">
            <li class="c3">
                <span class="c1">the right to withdraw consent. You also have the right to withdraw your consent at any time where we rely on your consent to process your personal information;</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">Please note that we may ask you to verify your identity before responding to such requests. Please note, we may not able to provide Service without some necessary data.</span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">You have the right to complain to a Data Protection Authority about our collection and use of your Personal Data. For more information, please contact your local data protection authority in the European Economic Area (EEA).</span>
        </p>
        <p class="c11">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="11">
            <li class="c0">
                <span class="c2">Your Data Protection Rights under the California Privacy Protection Act (CalOPPA)</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law&rsquo;s reach stretches well beyond California to require a person or company in the United States (and conceivable the world) that operates websites collecting personally identifiable information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being collected and those individuals with whom it is being shared, and to comply with this policy. &ndash; See more at: https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/ </span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">According to CalOPPA we agree to the following:</span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_f4qxt8xbott0-1 start" start="1">
            <li class="c3">
                <span class="c1">users can visit our site anonymously;</span>
            </li>
        </ol>
        <p class="c8 c9">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_y07lo0xltk3w-1 start" start="1">
            <li class="c3">
                <span class="c1">our Privacy Policy link includes the word &ldquo;Privacy&rdquo;, and can easily be found on the page specified above on the home page of our website;</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_krw496knqzv3-1 start" start="1">
            <li class="c3">
                <span class="c1">users will be notified of any privacy policy changes on our Privacy Policy Page;</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_kishoq74ra2x-1 start" start="1">
            <li class="c3">
                <span class="c1">users are able to change their personal information by emailing us at info@citizenj.org. </span>
            </li>
        </ol>
        <p class="c7">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">Our Policy on &ldquo;Do Not Track&rdquo; Signals:</span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We honor Do Not Track signals and do not track, plant cookies, or use advertising when a Do Not Track browser mechanism is in place. Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked. </span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.</span>
        </p>
        <p class="c11">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="12">
            <li class="c0">
                <span class="c2">Your Data Protection Rights under the California Consumer Privacy Act (CCPA)</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">If you are a California resident, you are entitled to learn what data we collect about you, ask to delete your data and not to sell (share) it. To exercise your data protection rights, you can make certain requests and ask us:</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_bq9zr4ss7xmq-1 start" start="1">
            <li class="c3">
                <span class="c6">What personal information we have about you</span><span class="c1">. If you make this request, we will return to you:</span>
            </li>
        </ol>
        <p class="c8 c9">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_78m8xj4as3kq-2 start" start="1">
            <li class="c10">
                <span class="c1">The categories of personal information we have collected about you.</span>
            </li>
        </ol>
        <p class="c8 c14">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_20i1x86iy11c-2 start" start="1">
            <li class="c10">
                <span class="c1">The categories of sources from which we collect your personal information.</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_6hv7djozfws5-2 start" start="1">
            <li class="c10">
                <span class="c1">The business or commercial purpose for collecting or selling your personal information.</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_jsjcwcjoi8xj-2 start" start="1">
            <li class="c10">
                <span class="c1">The categories of third parties with whom we share personal information.</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_7xzcbmszb9t0-2 start" start="1">
            <li class="c10">
                <span class="c1">The specific pieces of personal information we have collected about you.</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_87n5ckkym9w-2 start" start="1">
            <li class="c10">
                <span class="c1">A list of categories of personal information that we have sold, along with the category of any other company we sold it to. If we have not sold your personal information, we will inform you of that fact.</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_cjk89jyegcoo-2 start" start="1">
            <li class="c10">
                <span class="c1">A list of categories of personal information that we have disclosed for a business purpose, along with the category of any other company we shared it with.</span>
            </li>
        </ol>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c8 c9">
            <span class="c1">Please note, you are entitled to ask us to provide you with this information up to two times in a rolling twelve-month period. When you make this request, the information provided may be limited to the personal information we collected about you in the previous 12 months.</span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_9atzautdi7ol-1 start" start="1">
            <li class="c3">
                <span class="c6">To delete your personal information</span><span class="c15">. If you make this request, we will delete the personal information we hold about you as of the date of your request from our records and direct any service providers to do the same. In some cases, deletion may be accomplished through de-identification of the information. If you choose to delete your personal information, you may not be able to use certain functions that require your personal information to operate.</span><span class="c12 c6">&nbsp;</span>
            </li>
        </ol>
        <p class="c8 c9">
            <span class="c12 c6">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_9tb1723rhvnw-1 start" start="1">
            <li class="c3">
                <span class="c6">To stop selling your personal information</span><span class="c1">. We don&#39;t sell or rent your personal information to any third parties for any purpose. You are the only owner of your Personal Data and can request disclosure or deletion at any time.</span>
            </li>
        </ol>
        <p class="c8 c9">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c8 c9">
            <span class="c1">Please note, if you ask us to delete or stop selling your data, it may impact your experience with us, and you may not be able to participate in certain programs or membership services which require the usage of your personal information to function. But in no circumstances, we will discriminate against you for exercising your rights.</span>
        </p>
        <p class="c8 c9">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c8 c9">
            <span class="c1">To exercise your California data protection rights described above, please send your request(s) by one of the following means:</span>
        </p>
        <p class="c8 c9">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c8 c9">
            <span class="c1">By email: info@citizenj.org</span>
        </p>
        <p class="c8 c9">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">Your data protection rights, described above, are covered by the CCPA, short for the California Consumer Privacy Act. To find out more, visit the official California Legislative Information website. The CCPA took effect on 01/01/2020. </span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="13">
            <li class="c0">
                <span class="c2">Analytics</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We may use third-party Service Providers to monitor and analyze the use of our Service.</span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c12 c6">Google Analytics</span>
        </p>
        <p class="c5">
            <span class="c1">Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualise and personalise the ads of its own advertising network.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: https://policies.google.com/privacy?hl=en</span>
        </p>
        <p class="c5">
            <span class="c13">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We also encourage you to review the Google&#39;s policy for safeguarding your data: https://support.google.com/analytics/answer/6004245.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="14">
            <li class="c0">
                <span class="c2">CI/CD tools</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We may use third-party Service Providers to automate the development process of our Service. </span>
        </p>
        <p class="c5">
            <span class="c12 c6">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c6 c12">GitLab CI/CD</span>
        </p>
        <p class="c5">
            <span class="c12 c6">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">GitLab CI/CD is provided by GitLab, Inc.</span>
        </p>
        <p class="c5">
            <span class="c12 c6">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">GitLab CI (Continuous Integration) service is a part of GitLab that build and test the software whenever developer pushes code to application. </span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">GitLab CD (Continuous Deployment) is a software service that places the changes of every code in the production which results in every day deployment of production. </span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c15">For more information on what data GitLab CI/CD collects for what purpose and how the protection of the data is ensured, please visit GitLab CI/CD Privacy Policy page: https://about.gitlab.com/privacy/.</span>
        </p>
        <p class="c11 c16">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="15">
            <li class="c0">
                <span class="c2">Links to Other Sites</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party&#39;s site. We strongly advise you to review the Privacy Policy of every site you visit.</span>
        </p>
        <p class="c8">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</span>
        </p>
        <p class="c11 c16">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="16">
            <li class="c0">
                <span class="c2">Children&#39;s Privacy</span>
            </li>
        </ol>
        <p class="c7">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c7">
            <span class="c15">Our Services are not intended for use by children under the age of 13 (&ldquo;</span><span class="c6">Children</span><span class="c1">&rdquo;). </span>
        </p>
        <p class="c7">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c7">
            <span class="c1">We do not knowingly collect personally identifiable information from Children under 13. If you become aware that a Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from Children without verification of parental consent, we take steps to remove that information from our servers.</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="17">
            <li class="c0">
                <span class="c2">Changes to This Privacy Policy</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</span>
        </p>
        <p class="c8">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update &ldquo;effective date&rdquo; at the top of this Privacy Policy.</span>
        </p>
        <p class="c8">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</span>
        </p>
        <p class="c11">
            <span class="c1">&nbsp;</span>
        </p>
        <ol class="c4 lst-kix_rtg4hnmo7sde-0" start="18">
            <li class="c0">
                <span class="c2">Contact Us</span>
            </li>
        </ol>
        <p class="c5">
            <span class="c2">&nbsp;</span>
        </p>
        <p class="c5">
            <span class="c1">If you have any questions about this Privacy Policy, please contact us:</span>
        </p>
        <p class="c5">
            <span class="c1">&nbsp;</span>
        </p>
        <p class="c11 c16">
            <span class="c1">By email: info@citizenj.org.</span>
        </p>
        <p class="c11 c22">
            <span class="c12 c21"></span>
        </p>

    </Layout>
</template>

<script>
    import Layout from '@layouts/main';

    export default {
        /**
         * Custom page meta data property for the view components.
         *
         * @type {Object}
         */
        metaInfo () {
            return {
                title: 'Privacy Policy',
                meta: [
                    {
                        name: 'description',
                        content: 'Learn more about CitizenJ privacy policy.',
                    },
                ],
                link: [
                    {
                        rel: 'canonical',
                        href: '/privacy',
                    },
                ],
            };
        },

        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            Layout,
        },
    };
</script>

<style lang="scss" module>
    @import '@design';

    /* stylelint-disable */
    .c1 {
        @apply pl-8;
    }

    :global(p + .c4[start]) {
        font-size: 1.25rem;
        font-weight: 900;
    }

    :global(p + .c4[start='1']:not(.first)) {
        font-size: 1rem;
        font-weight: 500;
        list-style: disc;
    }

    :global(p + .c4.first) {
        font-size: 1.25rem;
        font-weight: 900;
    }

    :global(.c6) {
        font-weight: bold;
    }

    .body > div:first-of-type {
        max-width: 900px;
        margin: 0 auto;
    }
    /* stylelint-enable */
</style>
